"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

///<reference path="../api.d.ts" />
///<reference path="../../../shared/address/address-controller.ts" />
///<reference path="../../../../typings/tsd.d.ts" />
var agencyRegistration;
(function (agencyRegistration) {
    var controller;
    (function (controller) {
        var CreateController = function () {
            /*@ngInject*/

            function CreateController($rootScope, agentFactory, createService, addressService) {
                var _this = this;

                _classCallCheck(this, CreateController);

                // Properties
                this.loader = new common.Loader();
                this.addressLoader = new common.Loader();
                // Dependencies
                this.addressService = addressService;
                // Properties
                this.addressConfig = new address.controller.AddressConfig();
                this.agency = agentFactory.getAgency();
                // Get Fields
                this.loader.showLoader("Carregando...");
                createService.getFields().then(function (fields) {
                    _this.fieldOptions = fields;
                    _this.addressConfig.cities = fields.cities;
                }).finally(function () {
                    _this.loader.hide();
                });
                $rootScope["$createLoader"] = this.loader;
            }

            _createClass(CreateController, [{
                key: "getCity",
                value: function getCity() {
                    var _this2 = this;

                    this.addressConfig.loader.showLoader("Carregando cidades...");
                    this.addressService.getCity(this.agency.address.countryCode, this.agency.address.stateCode).then(function (cities) {
                        _this2.addressConfig.cities = cities;
                        _this2.agency.address.cityCode = cities[0].code;
                    }).finally(function () {
                        _this2.addressConfig.loader.hide();
                    });
                }
            }, {
                key: "addPhoneItem",
                value: function addPhoneItem() {
                    this.agency.companyData.phones.push({ type: 'T' });
                }
            }, {
                key: "removePhoneItem",
                value: function removePhoneItem(item) {
                    var index = this.agency.companyData.phones.indexOf(item);
                    this.agency.companyData.phones.splice(index, 1);
                }
            }]);

            return CreateController;
        }();

        controller.CreateController = CreateController;
    })(controller = agencyRegistration.controller || (agencyRegistration.controller = {}));
})(agencyRegistration || (agencyRegistration = {}));
angular.module('agencyRegistrationApp').controller('CreateController', agencyRegistration.controller.CreateController);